import classNames from "classnames";
import React, { HTMLAttributes } from "react";

export type RowProps = HTMLAttributes<HTMLDivElement> & {
    children?: React.ReactNode;
    className?: string;
    form?: boolean;
    noGutters?: boolean;
    xs?: number | string;
    sm?: number | string;
    md?: number | string;
    lg?: number | string;
    xl?: number | string;
};

const colWidths = ["xs", "sm", "md", "lg", "xl"];

const Row = ({ children, className, noGutters, form, ...props }: RowProps) => {
    const colClasses: Array<string> = [];

    colWidths.forEach((colWidth, i) => {
        // @ts-ignore
        let colSize = props[colWidth];

        if (!colSize) {
            return;
        }

        const isXs = !i;
        colClasses.push(
            isXs ? `row-cols-${colSize}` : `row-cols-${colWidth}-${colSize}`,
        );
    });

    const classes = classNames(
        className,
        noGutters ? "no-gutters" : null,
        form ? 'form-row' : 'row',
        colClasses,
    );

    return <div className={classes}>{children}</div>;
};

export { Row };
